import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  friendRequestResponse,
  cancelOutgoingFriendRequest,
  loadFriendsStart,
  getFriendRequestCount,
  deleteCurrentFriend
} from '../../redux/modules/friends'
import { InputError } from '@foodsby/nutrient'
import { Article, Card } from '../common/Layout'
import CurrentFriends from './CurrentFriends'
import PendingRequests from './PendingRequests'
import URLSearchParams from 'url-search-params'

class FriendManager extends Component {
  constructor(props) {
    super(props)
    const queryString = new URLSearchParams(window.location.search)
    const newFriend = queryString.get('connectionId')
    if (newFriend !== null) {
      this.props.friendRequestResponse({
        action: 'ACCEPT',
        requestId: newFriend
      })
    }
  }
  componentDidMount() {
    if (!this.props.friends && !this.props.isLoadingFriends) {
      this.props.loadFriendsStart()
    }
  }

  render() {
    const {
      loadFriendsError,
      friends,
      isLoadingFriends,
      incomingFriendRequests,
      outgoingFriendRequests,
      isLoadingFriendRequests,
      friendRequestResponse,
      friendRequestResponseError,
      friendRequestLoadingError,
      cancelOutgoingFriendRequest,
      cancelOutgoingRequestError,
      deleteCurrentFriend,
      deletingFriendError,
      isRespondingToFriendRequest,
      isCancelingOutgoingRequest
    } = this.props
    return (
      <Article>
        <Card>
          <div className="friendManagerBanner">
            <div className="requestTabs">
              <div className="active">Pending Requests </div>
            </div>
          </div>
          <PendingRequests
            {...{
              isRespondingToFriendRequest,
              incomingFriendRequests,
              outgoingFriendRequests,
              isLoadingFriendRequests,
              friendRequestResponse,
              friendRequestLoadingError,
              friendRequestResponseError,
              cancelOutgoingFriendRequest,
              cancelOutgoingRequestError,
              isLoadingFriends,
              isCancelingOutgoingRequest
            }}
          />
        </Card>
        <Card>
          <div className="friendManagerBanner">
            <div className="requestTabs">
              <div className="active">Your Friends</div>
            </div>
          </div>
          <CurrentFriends
            {...{
              friends,
              isRespondingToFriendRequest,
              isLoadingFriends,
              deleteCurrentFriend,
              deletingFriendError,
              loadFriendsError,
              isLoadingFriendRequests,
              isCancelingOutgoingRequest
            }}
          />
          {loadFriendsError && (
            <InputError visible={loadFriendsError && loadFriendsError !== null}>
              {loadFriendsError}
            </InputError>
          )}
        </Card>
      </Article>
    )
  }
}
const mapStateToProps = state => {
  const {
    isLoadingFriends,
    loadFriendsError,
    incomingFriendRequests,
    friends,
    deletingFriendError,
    outgoingFriendRequests,
    isLoadingFriendRequests,
    friendRequestResponseError,
    friendRequestLoadingError,
    cancelOutgoingRequestError,
    isRespondingToFriendRequest,
    isCancelingOutgoingRequest
  } = state.friends
  return {
    isLoadingFriends,
    loadFriendsError,
    incomingFriendRequests,
    deletingFriendError,
    friends,
    outgoingFriendRequests,
    isLoadingFriendRequests,
    friendRequestResponseError,
    friendRequestLoadingError,
    cancelOutgoingRequestError,
    isRespondingToFriendRequest,
    isCancelingOutgoingRequest
  }
}
const mapDispatchToProps = {
  loadFriendsStart,
  getFriendRequestCount,
  deleteCurrentFriend,
  friendRequestResponse,
  cancelOutgoingFriendRequest
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FriendManager)
